import classNames from 'classnames'
import { Modal } from 'react-bootstrap'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import WklItem from './wkl-item'
import MntItem from './mnt-item'
interface IModalProps {
    show: boolean
    onHide: () => void
    setSelectedTab: React.Dispatch<React.SetStateAction<string>>
    setDateValue: React.Dispatch<React.SetStateAction<number>>
    selectedTab: string
}
export default function SelectDateModal({
    show,
    onHide,
    setSelectedTab,
    setDateValue,
    selectedTab,
}: IModalProps) {
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <div className=" p-3 h-[400px] overflow-y-scroll">
                <Tabs defaultIndex={selectedTab === 'wkl' ? 0 : 1}>
                    <TabList>
                        <div className=" flex w-full justify-between text-center">
                            <Tab
                                className={classNames(
                                    'w-full py-2',
                                    selectedTab === 'wkl' &&
                                        ' text-green-1 border-b border-green-1'
                                )}
                                onClick={() => setSelectedTab('wkl')}
                            >
                                هفتگی
                            </Tab>
                            <Tab
                                className={classNames(
                                    'w-full py-2',
                                    selectedTab === 'mnt' &&
                                        ' text-green-1 border-b border-green-1'
                                )}
                                onClick={() => setSelectedTab('mnt')}
                            >
                                ماهانه
                            </Tab>
                        </div>
                    </TabList>
                    <div className=" mt-4">
                        <TabPanel>
                            <WklItem
                                setDateValue={setDateValue}
                                onHide={onHide}
                            />
                        </TabPanel>
                        <TabPanel>
                            <MntItem
                                setDateValue={setDateValue}
                                onHide={onHide}
                            />
                        </TabPanel>
                    </div>
                </Tabs>
            </div>
        </Modal>
    )
}
